import React, { useEffect, useState } from 'react'
import * as locCon from "../LocalConstants"
import { formatToStudyLocationReadable } from '../community-hats-js-library/utils/dateFunctions'
import CustomText from './CustomText'

function SimpleClock() {

    const [date, setDate] = useState(new Date())

    useEffect(() => {


        const timer = setInterval(() => setDate(new Date()), 1000 * 60)

        return () => {
            clearInterval(timer)
        }
    })


    return (
        <CustomText type={locCon.ELEMENT_TITLE_TEXT}>{formatToStudyLocationReadable(date, true, true, false)}</CustomText>
    )
}

export default SimpleClock